import { render, staticRenderFns } from "./FullTitle.vue?vue&type=template&id=05b8447f&"
import script from "./FullTitle.ts?vue&type=script&lang=ts&"
export * from "./FullTitle.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports